(function () {
  const POPUP_SELECTOR = '[data-dm-upgrade-popup]';
  const ACCORDION_SELECTOR = '.dm-easyflow-accordion';
  const CONTENT_SELECTOR = '.dm-easyflow-accordion__content';
  const EASYFLOW_ROOT_SELECTOR = '.ef__product-option-root, .ef__product-option';
  const EASYFLOW_INPUT_SELECTOR = '.ef__product-option-input, input[name*="properties"], select[name*="properties"], textarea[name*="properties"]';
  const PRODUCT_FORM_SELECTOR = 'form[action*="/cart/add"]';
  const UPGRADE_TRIGGER_SELECTOR = '[data-dm-upgrade-trigger]';

  let activeForm = null;
  let activeTrigger = null;
  let isOpen = false;
  let isContinuing = false;
  let bypassForms = new WeakSet();
  let movedNodes = [];
  let returnMarker = null;
  let activeDetails = null;
  let activeDetailsWasOpen = false;

  const popup = document.querySelector(POPUP_SELECTOR);
  if (!popup) return;

  document.body.appendChild(popup);

  const dialog = popup.querySelector('.dm-upgrade-popup__dialog');
  const optionSlot = popup.querySelector('[data-dm-upgrade-options]');
  const submitButton = popup.querySelector('[data-dm-upgrade-submit]');
  const skipButton = popup.querySelector('[data-dm-upgrade-skip]');
  const closeButtons = popup.querySelectorAll('[data-dm-upgrade-close]');

  const pushEvent = (eventName, extraData = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...extraData });
  };

  const findPrimaryProductForm = () => {
    return document.querySelector('.product__sale-box product-form form[action*="/cart/add"]') ||
      document.querySelector('.product__info-container product-form form[action*="/cart/add"]') ||
      document.querySelector(PRODUCT_FORM_SELECTOR);
  };

  const isNoUpgradeText = (text) => {
    const normalized = (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return normalized.includes('geen upgrade') ||
      normalized.includes('geen muis') ||
      normalized.includes('zonder upgrade') ||
      normalized.includes('zonder upgrades') ||
      normalized === 'geen' ||
      normalized === 'nee' ||
      normalized === 'no' ||
      normalized === 'none';
  };

  const hasUpgradeValue = (control) => {
    if (!control || control.type === 'hidden' || control.disabled) return false;

    const rawPrice = control.dataset && control.dataset.valuePrice;
    if (rawPrice && Number(rawPrice) > 0) return true;
    if (control.dataset && control.dataset.variantId) return true;

    if (control.tagName === 'SELECT') {
      return [...control.options].some((option) => {
        const optionPrice = option.dataset && option.dataset.valuePrice;
        if (optionPrice && Number(optionPrice) > 0) return true;
        if (option.dataset && option.dataset.variantId) return true;

        const value = (option.value || '').trim();
        const text = option.textContent || '';
        return value && value !== '0' && !isNoUpgradeText(text);
      });
    }

    return false;
  };

  const hasMeaningfulEasyFlowOption = (content) => {
    if (!content) return false;

    const controls = [...content.querySelectorAll(EASYFLOW_INPUT_SELECTOR)]
      .filter((control) => control.type !== 'hidden' && !control.disabled);

    return controls.some((control) => hasUpgradeValue(control));
  };

  const getUpgradeContent = () => {
    const accordion = document.querySelector(ACCORDION_SELECTOR);
    if (!accordion) return null;

    const details = accordion.querySelector('details');
    const content = accordion.querySelector(CONTENT_SELECTOR);
    if (!hasMeaningfulEasyFlowOption(content)) return null;

    const movableNodes = [...content.childNodes].filter((node) => {
      return node.nodeType === Node.ELEMENT_NODE || (node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    });

    if (movableNodes.length === 0) return null;

    return {
      accordion,
      details,
      content,
      detailsWasOpen: Boolean(details && details.open),
      movableNodes
    };
  };

  const refreshUpgradeTriggers = () => {
    const upgradeContent = getUpgradeContent();
    const hasUpgrades = Boolean(upgradeContent);

    if (upgradeContent && upgradeContent.accordion) {
      upgradeContent.accordion.classList.add('dm-easyflow-accordion--has-upgrades');
    } else {
      document.querySelectorAll(ACCORDION_SELECTOR).forEach((accordion) => {
        accordion.classList.remove('dm-easyflow-accordion--has-upgrades');
      });
    }

    document.querySelectorAll(UPGRADE_TRIGGER_SELECTOR).forEach((button) => {
      button.hidden = !hasUpgrades;
    });
  };

  const setPopupButtonsDisabled = (disabled) => {
    submitButton.disabled = disabled;
    skipButton.disabled = disabled;
  };

  const getOptionHint = (text) => {
    const normalized = (text || '').toLowerCase();
    if (normalized.includes('ram') || normalized.includes('werkgeheugen') || normalized.includes('geheugen')) {
      return "Meer werkgeheugen helpt vooral bij multitasken, veel browsertabs en zwaardere programma's.";
    }
    if (normalized.includes('ssd') || normalized.includes('opslag') || normalized.includes('schijf') || normalized.includes('storage')) {
      return "Meer opslagruimte geeft extra plek voor bestanden, programma's en lokale back-ups.";
    }
    return '';
  };

  const addOptionHints = () => {
    const controls = [...optionSlot.querySelectorAll(EASYFLOW_INPUT_SELECTOR)];
    const handledGroups = new Set();

    controls.forEach((control) => {
      const group = control.closest('.ef__product-option, .ef__product-option-root, fieldset, [class*="option"]') || control.parentElement;
      if (!group || handledGroups.has(group)) return;

      const label = group.querySelector('label, legend, [class*="title"], [class*="label"]');
      const labelText = label ? label.textContent : group.textContent;
      const hint = getOptionHint(labelText);
      if (!hint || group.querySelector('.dm-upgrade-popup__option-hint')) return;

      const hintElement = document.createElement('span');
      hintElement.className = 'dm-upgrade-popup__option-hint';
      hintElement.textContent = hint;

      if (label && label.parentNode) {
        label.insertAdjacentElement('afterend', hintElement);
      } else {
        group.insertBefore(hintElement, group.firstChild);
      }

      handledGroups.add(group);
    });
  };

  const restoreUpgradeContent = () => {
    if (!returnMarker || !returnMarker.parentNode) return;

    movedNodes.forEach((node) => {
      returnMarker.parentNode.insertBefore(node, returnMarker);
    });
    returnMarker.remove();
    returnMarker = null;
    movedNodes = [];

    if (activeDetails) {
      activeDetails.open = activeDetailsWasOpen;
      activeDetails = null;
      activeDetailsWasOpen = false;
    }
  };

  const moveUpgradeContentToPopup = (upgradeContent) => {
    restoreUpgradeContent();
    optionSlot.innerHTML = '';
    returnMarker = document.createComment('dm-upgrade-popup-return');
    upgradeContent.content.appendChild(returnMarker);
    movedNodes = upgradeContent.movableNodes;
    movedNodes.forEach((node) => optionSlot.appendChild(node));
  };

  const submitFormOnce = (form) => {
    if (!form) return;

    bypassForms.add(form);
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }

    const submitter = form.querySelector('[type="submit"], button[name="add"]');
    if (submitter) submitter.click();
    else form.submit();
  };

  const clearEasyFlowSelections = () => {
    const controls = [...optionSlot.querySelectorAll(EASYFLOW_INPUT_SELECTOR)];

    controls.forEach((control) => {
      if (control.type === 'checkbox' || control.type === 'radio') {
        if (control.checked) {
          control.checked = false;
          control.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (control.tagName === 'SELECT') {
        const emptyOption = [...control.options].find((option) => {
          const value = (option.value || '').trim().toLowerCase();
          const text = (option.textContent || '').trim().toLowerCase();
          return value === '' || value === '0' || text.includes('geen') || text.includes('zonder');
        });

        if (emptyOption && control.value !== emptyOption.value) {
          control.value = emptyOption.value;
          control.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (control.value) {
        control.value = '';
        control.dispatchEvent(new Event('input', { bubbles: true }));
        control.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  const closePopup = (reason = 'close') => {
    if (!isOpen) return;

    isOpen = false;
    popup.hidden = true;
    document.body.classList.remove('dm-upgrade-popup-open');
    restoreUpgradeContent();
    setPopupButtonsDisabled(false);

    if (reason === 'close') {
      pushEvent('upgrade_offer_close');
    }

    if (activeTrigger && typeof activeTrigger.focus === 'function') {
      activeTrigger.focus({ preventScroll: true });
    }
  };

  const openPopup = (upgradeContent, form, trigger) => {
    activeForm = form;
    activeTrigger = trigger || document.activeElement;
    activeDetails = upgradeContent.details || null;
    activeDetailsWasOpen = Boolean(upgradeContent.detailsWasOpen);

    if (upgradeContent.accordion) {
      upgradeContent.accordion.classList.add('dm-easyflow-accordion--has-upgrades');
    }

    popup.hidden = false;
    document.body.classList.add('dm-upgrade-popup-open');
    isOpen = true;
    pushEvent('upgrade_offer_view');
    moveUpgradeContentToPopup(upgradeContent);
    addOptionHints();

    window.setTimeout(() => dialog.focus(), 0);
  };

  const continueWithForm = (eventName, shouldClearSelections) => {
    if (isContinuing) return;
    isContinuing = true;
    setPopupButtonsDisabled(true);

    if (shouldClearSelections) {
      clearEasyFlowSelections();
    }

    pushEvent(eventName);
    const form = activeForm || findPrimaryProductForm();
    closePopup('continue');
    submitFormOnce(form);

    window.setTimeout(() => {
      isContinuing = false;
      setPopupButtonsDisabled(false);
    }, 1200);
  };

  const maybeOpenUpgradePopup = (form, trigger) => {
    if (!form || bypassForms.has(form)) return false;
    if (isOpen) return true;

    const upgradeContent = getUpgradeContent();
    if (!upgradeContent) return false;

    openPopup(upgradeContent, form, trigger);
    return true;
  };

  const watchUpgradeContent = () => {
    const accordion = document.querySelector(ACCORDION_SELECTOR);
    if (!accordion || !('MutationObserver' in window)) return;

    let refreshTimer = null;
    const observer = new MutationObserver(() => {
      if (isOpen) return;

      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refreshUpgradeTriggers, 50);
    });

    observer.observe(accordion, {
      attributes: true,
      childList: true,
      subtree: true
    });
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(PRODUCT_FORM_SELECTOR)) return;

    if (bypassForms.has(form)) {
      bypassForms.delete(form);
      return;
    }

    const productForm = form.closest('product-form');
    if (!productForm || productForm.closest('quick-add-drawer') || productForm.closest('cart-drawer')) return;

    if (maybeOpenUpgradePopup(form, event.submitter || document.activeElement)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const upgradeTrigger = event.target.closest(UPGRADE_TRIGGER_SELECTOR);
    if (upgradeTrigger) {
      const form = upgradeTrigger.closest('form') || findPrimaryProductForm();
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!maybeOpenUpgradePopup(form, upgradeTrigger)) {
        refreshUpgradeTriggers();
      }
      return;
    }

    const stickyButton = event.target.closest('#dmStickyAtcBtn');
    if (!stickyButton) return;

    const form = findPrimaryProductForm();
    if (!form) return;

    if (maybeOpenUpgradePopup(form, stickyButton)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  optionSlot.addEventListener('change', (event) => {
    if (event.target.matches(EASYFLOW_INPUT_SELECTOR)) {
      pushEvent('upgrade_option_select');
    }
  });

  submitButton.addEventListener('click', () => continueWithForm('upgrade_added', false));
  skipButton.addEventListener('click', () => continueWithForm('upgrade_offer_skip', true));

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => closePopup('close'));
  });

  popup.addEventListener('click', (event) => {
    if (event.target === popup) {
      closePopup('close');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen) {
      closePopup('close');
    }
  });

  refreshUpgradeTriggers();
  watchUpgradeContent();
})();
